import { useQuery } from "@apollo/client";
import getSymbolFromCurrency from "currency-symbol-map";
import { useState } from "react";
import DialogModal from "src/components/Dialog";
import { GetAsoEbi, GetAsoEbiAttires } from "src/graphql/queries";
import { formatMoney } from "src/helper/functions";
import useAppStore from "src/store/utils";
import {
  AseobiOrder,
  GetAseobi,
  GetAseobiAttires,
  GetAseobiAttiresVariables,
  GetAseobiVariables,
} from "src/utils/gql_types";
import OrderDetails from "../OrderDetails";

interface Props {
  order: AseobiOrder;
}

const AsoebiOrder = ({ order }: Props) => {
  const { event } = useAppStore((state) => state);

  const [attireImg, setAttireImg] = useState<string>("");
  const [attireName, setAttireName] = useState<string>("");
  const [asoebiName, setAsoebiName] = useState("");

  const fullname = `${order.user.first_name} ${order.user.last_name}`;

  useQuery<GetAseobi, GetAseobiVariables>(GetAsoEbi, {
    variables: {
      event_id: event.uuid,
    },
    fetchPolicy: "cache-first",
    onCompleted(data) {
      const matchedAsoebi = data.getAseobi.find(
        (asoebi) => asoebi.id === order.aseobi_id
      );
      setAsoebiName(matchedAsoebi?.name ?? "");
    },
  });

  useQuery<GetAseobiAttires, GetAseobiAttiresVariables>(GetAsoEbiAttires, {
    variables: {
      event_id: event.uuid,
      aseobi_id: order.aseobi_id ?? "",
    },
    fetchPolicy: "cache-first",
    onCompleted(data) {
      const matchedAttire = data.getAseobiAttires.find(
        (attire) => attire.id === order.aseobi_attire_id
      );
      setAttireImg(matchedAttire?.images[0] ?? "");
      setAttireName(matchedAttire?.name ?? "");
    },
  });

  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="flex cursor-pointer flex-col gap-4 rounded-xl border p-4 shadow-lg transition duration-300 hover:scale-[1.02] lg:flex-row lg:justify-between xl:px-8"
        onClick={() => setOpen(true)}
      >
        <div className="lg:flex lg:flex-row lg:gap-6 xl:gap-24">
          <div className="mb-4 flex flex-col gap-1">
            <p className="text-sm md:text-base">{fullname}</p>
            <p className="text-sm text-gray-500">
              {order.contact_phone_number}
            </p>
            <p className="text-sm text-gray-500">{order.contact_email}</p>
            <p className="text-sm text-gray-500">{order.delivery_address}</p>
          </div>

          <div
            className="flex items-center gap-2"
            onClick={() => setOpen(true)}
          >
            <div className="flex gap-1">
              <div className="h-10 w-10">
                {attireImg && (
                  <img
                    src={attireImg ?? ""}
                    alt=".."
                    className="h-full w-full object-cover"
                  />
                )}
              </div>
              {/* <div className="h-10 w-10 bg-red-400"></div>
              <div className="h-10 w-10 bg-red-400"></div> */}
            </div>
            <p className="text-sm text-[#475868]">From {asoebiName}</p>
          </div>
        </div>
        <div className="flex items-center justify-between lg:gap-12">
          <p className="font-semibold">
            {getSymbolFromCurrency("NGN")}
            {formatMoney(order.total_price)}
          </p>
          <button
            className="w-20 rounded-md bg-primary-5 py-2 text-white hover:bg-primary-1"
            onClick={(e) => {
              e?.stopPropagation();
            }}
          >
            <a
              href={`https://wa.me/${order.contact_phone_number}`}
              target="_blank"
              rel="noreferrer"
            >
              Chat
            </a>
          </button>
        </div>
      </div>
      <DialogModal open={open} onOpenChange={setOpen}>
        <OrderDetails
          asoebiName={asoebiName}
          attireImg={attireImg}
          attireName={attireName}
          price_per_yard={order.price_per_yard}
          total_price={order.total_price}
          yards={order.yards}
          fullname={fullname}
        />
      </DialogModal>
    </>
  );
};

export default AsoebiOrder;
